import { render, staticRenderFns } from "./LoyaltyHeader.vue?vue&type=template&id=8335e72a&scoped=true"
import script from "./LoyaltyHeader.vue?vue&type=script&lang=js"
export * from "./LoyaltyHeader.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyHeader.vue?vue&type=style&index=0&id=8335e72a&prod&lang=css"
import style1 from "./LoyaltyHeader.vue?vue&type=style&index=1&id=8335e72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8335e72a",
  null
  
)

export default component.exports